module.exports = __webpack_public_path__ + "img/bluesky3100_29.1ee7d514.jpg";